import api from './api';

const VAPID_PUBLIC_KEY = 'BJPmU-v2JmehXCsXsOodxyjBrOxPck8EuCl8R-fXC0jc34N6Bkq5VUn7MiftmajDjBuzHCGJXpahQ5OuuQJ6bLY';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const pushService = {
  /**
   * Check if push is supported by this browser
   */
  isSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  },

  /**
   * Register the service worker and subscribe to push notifications.
   * Sends the subscription to the backend.
   */
  async subscribe() {
    if (!this.isSupported()) {
      console.log('[Push] Not supported in this browser');
      return false;
    }

    try {
      // Request notification permission
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('[Push] Permission denied');
        return false;
      }

      // Register service worker
      const registration = await navigator.serviceWorker.register('/sw.js');
      await navigator.serviceWorker.ready;

      // Subscribe to push
      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
      }

      // Send subscription to backend
      const subJson = subscription.toJSON();
      await api.post('/restaurants/push/subscribe', {
        endpoint: subJson.endpoint,
        p256dh: subJson.keys.p256dh,
        auth: subJson.keys.auth,
      });

      console.log('[Push] Subscribed successfully');
      return true;
    } catch (err) {
      console.error('[Push] Error subscribing:', err);
      return false;
    }
  },

  /**
   * Unsubscribe from push notifications
   */
  async unsubscribe() {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
          await subscription.unsubscribe();
          await api.post('/restaurants/push/unsubscribe', {
            endpoint: subscription.endpoint,
          });
        }
      }
    } catch (err) {
      console.error('[Push] Error unsubscribing:', err);
    }
  },
};

export default pushService;
